(function () {
  "use strict";

  if (!window.sessionStorage) return;

  var pathname = window.location.pathname || "";
  var isCollectionOrSearch =
    pathname.indexOf("/collections/") === 0 || pathname.indexOf("/search") === 0;

  if (!isCollectionOrSearch) return;

  var FILTER_URL_KEY = "pd_globo_filter_url";
  var RESTORE_ONCE_KEY = "pd_globo_restore_once";
  var RELOAD_ONCE_KEY = "pd_globo_reload_once";
  var PAGINATION_INTENT_KEY = "pd_globo_pagination_intent";
  var HYDRATION_CHECK_TOKEN = 0;

  function getParams(url) {
    try {
      return new URL(url, window.location.origin).searchParams;
    } catch (error) {
      return new URLSearchParams("");
    }
  }

  function hasGfParams(params) {
    var iterator = params.keys();
    var next = iterator.next();

    while (!next.done) {
      if (String(next.value).indexOf("gf_") === 0) return true;
      next = iterator.next();
    }

    return false;
  }

  function getGfEntries(params) {
    var values = [];
    var iterator = params.entries();
    var next = iterator.next();

    while (!next.done) {
      if (String(next.value[0]).indexOf("gf_") === 0) {
        values.push([String(next.value[0]), String(next.value[1])]);
      }
      next = iterator.next();
    }

    return values;
  }

  function hasGloboDom() {
    return Boolean(
      document.getElementById("gf-tree") &&
        document.getElementById("gf-grid") &&
        document.getElementById("gf-products") &&
        document.getElementById("gf-controls-container")
    );
  }

  function hasSelectedFilters() {
    return Boolean(
      document.querySelector(".globo-selected-items .selected-item") ||
        document.querySelector(".globo-selected-items-wrapper .selected-item")
    );
  }

  function markFilteredUrlIfPresent() {
    var params = getParams(window.location.href);
    if (!hasGfParams(params)) return;
    sessionStorage.setItem(FILTER_URL_KEY, window.location.href);
  }

  function canUseSavedUrl(savedUrl) {
    if (!savedUrl) return false;

    try {
      var parsed = new URL(savedUrl, window.location.origin);
      return (
        parsed.pathname === window.location.pathname && hasGfParams(parsed.searchParams)
      );
    } catch (error) {
      return false;
    }
  }

  function buildRestoredUrl(savedUrl) {
    try {
      var saved = new URL(savedUrl, window.location.origin);
      var current = new URL(window.location.href, window.location.origin);
      if (saved.pathname !== current.pathname) return "";

      var gfEntries = getGfEntries(saved.searchParams);
      if (!gfEntries.length) return "";

      for (var index = 0; index < gfEntries.length; index++) {
        var pair = gfEntries[index];
        if (!current.searchParams.has(pair[0])) {
          current.searchParams.set(pair[0], pair[1]);
        }
      }

      var restored = current.toString();
      return restored !== window.location.href ? restored : "";
    } catch (error) {
      return "";
    }
  }

  function setPaginationIntent() {
    sessionStorage.setItem(
      PAGINATION_INTENT_KEY,
      JSON.stringify({
        at: Date.now(),
        from: window.location.href,
      })
    );
  }

  function hasRecentPaginationIntent() {
    try {
      var raw = sessionStorage.getItem(PAGINATION_INTENT_KEY);
      if (!raw) return false;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.at || !parsed.from) return false;
      if (Date.now() - Number(parsed.at) > 12000) return false;

      var from = new URL(parsed.from, window.location.origin);
      return (
        from.pathname === window.location.pathname && hasGfParams(from.searchParams)
      );
    } catch (error) {
      return false;
    }
  }

  function shouldRestoreDroppedParams(trigger) {
    if (hasRecentPaginationIntent()) return true;
    return trigger === "render" && hasSelectedFilters();
  }

  function restoreParamsIfDropped(trigger) {
    var currentParams = getParams(window.location.href);
    if (hasGfParams(currentParams)) return false;

    var savedUrl = sessionStorage.getItem(FILTER_URL_KEY);
    if (!canUseSavedUrl(savedUrl)) return false;
    if (!shouldRestoreDroppedParams(trigger)) return false;
    if (sessionStorage.getItem(RESTORE_ONCE_KEY) === window.location.href) return false;

    var restoredUrl = buildRestoredUrl(savedUrl);
    if (!restoredUrl) return false;

    sessionStorage.setItem(RESTORE_ONCE_KEY, window.location.href);
    sessionStorage.removeItem(PAGINATION_INTENT_KEY);
    window.location.replace(restoredUrl);
    return true;
  }

  function reloadIfHydrationMissing() {
    var currentUrl = window.location.href;
    if (sessionStorage.getItem(RELOAD_ONCE_KEY) === currentUrl) return;

    sessionStorage.setItem(RELOAD_ONCE_KEY, currentUrl);
    window.location.reload();
  }

  function clearRecoveryGuardsIfStable() {
    if (!hasGloboDom()) return;

    var currentParams = getParams(window.location.href);
    var currentHasGf = hasGfParams(currentParams);

    sessionStorage.removeItem(RESTORE_ONCE_KEY);

    if (!currentHasGf || hasSelectedFilters()) {
      sessionStorage.removeItem(RELOAD_ONCE_KEY);
    }

    if (currentHasGf) {
      // Consume pagination intent as soon as a filtered view is stable.
      sessionStorage.removeItem(PAGINATION_INTENT_KEY);
    } else if (!hasSelectedFilters()) {
      sessionStorage.removeItem(PAGINATION_INTENT_KEY);
    }
  }

  function scheduleHydrationCheck() {
    var params = getParams(window.location.href);
    if (!hasGfParams(params)) return;

    HYDRATION_CHECK_TOKEN += 1;
    var token = HYDRATION_CHECK_TOKEN;
    var tries = 0;

    function check() {
      if (token !== HYDRATION_CHECK_TOKEN) return;

      var currentParams = getParams(window.location.href);
      if (!hasGfParams(currentParams)) return;

      if (hasGloboDom()) {
        clearRecoveryGuardsIfStable();
        return;
      }

      tries += 1;
      if (tries < 6) {
        window.setTimeout(check, 500);
        return;
      }

      if (document.visibilityState === "hidden") return;
      reloadIfHydrationMissing();
    }

    window.setTimeout(check, 500);
  }

  function verifyGloboState(trigger) {
    markFilteredUrlIfPresent();

    if (restoreParamsIfDropped(trigger || "generic")) return;

    var params = getParams(window.location.href);
    if (!hasGfParams(params)) {
      clearRecoveryGuardsIfStable();
      return;
    }

    scheduleHydrationCheck();
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var isPaginationClick = target.closest(
        "#gf_pagination_wrap a, #gf_pagination_wrap button, .pagination a, .pagination button"
      );

      if (!isPaginationClick) return;
      if (!hasGfParams(getParams(window.location.href))) return;

      markFilteredUrlIfPresent();
      setPaginationIntent();
    },
    true
  );

  document.addEventListener("globoFilterRenderCompleted", function () {
    verifyGloboState("render");
  });
  window.addEventListener("popstate", function () {
    window.setTimeout(function () {
      verifyGloboState("popstate");
    }, 0);
  });
  window.addEventListener("pageshow", function () {
    window.setTimeout(function () {
      verifyGloboState("pageshow");
    }, 0);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      verifyGloboState("ready");
    });
  } else {
    verifyGloboState("ready");
  }
})();
